import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const deleteRecitalAPI = async (recitalId: string) => {
  const response = await baseAPI.delete(`/recitals/${recitalId}`);
  return response.data;
};

export const useDeleteRecitalMutation = () => {
  return useMutation({
    mutationFn: async (recitalId: string) => {
      return await deleteRecitalAPI(recitalId);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.RECITALS],
      });
    },
  });
};
